import { CALL_API } from './api'

export default store => next => action => {
    const entry = action[CALL_API]


    if (typeof entry !== 'object') return next(action)

    next(action)
}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js